import React from 'react';
import { Button as MuiButton } from '@mui/material';

const CustomButton = ({ 
  children, 
  variant = 'normal', 
  disabled = false, 
  onClick, 
  type = 'button',
  sx = {},
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    height: '38px',
    padding: '10px 30px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '16px',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    '&:focus': {
      boxShadow: 'none',
    },
    ...sx
  };

  const variantStyles = {
    normal: {
      background: '#FF43AA',
      color: '#FFF',      
      '&:disabled': {
        background: 'rgba(0, 0, 0, 0.03)',
        color: 'rgba(0, 0, 0, 0.30)',
      }
    },
    gray: {
      background: 'rgba(0, 0, 0, 0.30)',
      color: '#FFF',     
      '&:disabled': {
        background: 'rgba(0, 0, 0, 0.03)',
        color: 'rgba(0, 0, 0, 0.30)',
      }
    }
  };

  return (
    <MuiButton
      variant="contained"
      disabled={disabled}
      onClick={onClick}
      type={type}
      sx={{
        ...baseStyles,
        ...variantStyles[variant]
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default CustomButton; 